import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'keys', standalone: false })
export class KeysPipe implements PipeTransform {
  transform(value: any, _args?: string[]): any {
    const keys: any[] = [];
    // tslint:disable-next-line:forin
    for (const key in value) {
      keys.push(key);
    }
    return keys;
  }
}
